import { SubmissionError } from 'redux-form'

export default function (request) {
  return request.catch(error => { throw new SubmissionError(error.response) })
}
